import store from "../../../store/store"
import {MessageBox} from 'element-ui'
import config from '../config'
export default {
	img(url){
		if(url){
            if(url.indexOf('http') >= 0){
                return url
            }
			return config.baseUrl + url;
		}
		return '';
	},
	cloneObj(obj){
		return JSON.parse(JSON.stringify(obj));
	},
	generateUUID() {
        var d = new Date().getTime();
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
        return uuid;
    },
	checkPermission(permission){
		return true;
        let routers = store.getters['admin/routers'];
        if(routers.indexOf(permission) >= 0){
        	return true;
        }
        return false;
	},
	cacheSet(key, value){
		localStorage.setItem(key, value);
	},
	cacheGet(key){
		return localStorage.getItem(key);
	},
	showImage(image) {
		MessageBox.alert('<img src="'+ image +'" style="width: 100%" />', {
			dangerouslyUseHTMLString: true
		});
	},
    showKeyword(str, keyword){
        if(!str){
            return ''
        }
        if(!keyword){
            return str
        }
        return str.replace(keyword, '<span style="color:red; font-size: 12px;">'+ keyword +'</span>')
    },
    copy(content){
        const ele = document.createElement('input')
        ele.setAttribute('value', content)
        document.body.appendChild(ele)
        ele.select()
        document.execCommand('copy')
        document.body.removeChild(ele)
        Message({
            message: '复制成功',
            type: 'success'
        })
    },
    calStyle(config){
        let style = {}
        if(config.backgroundColor){
            style.backgroundColor = config.backgroundColor
        }
        if(config.color){
            style.color = config.color
        }
        if(config.fontSize){
            style.fontSize = config.fontSize + 'px'
        }
        if(config.marginLeft){
            style.marginLeft = config.marginLeft + 'px'
        }
        if(config.marginTop){
            style.marginTop = config.marginTop + 'px'
        }
        if(config.marginRight){
            style.marginRight = config.marginRight + 'px'
        }
        if(config.marginBottom){
            style.marginBottom = config.marginBottom + 'px'
        }

        if(config.paddingLeft){
            style.paddingLeft = config.paddingLeft + 'px'
        }
        if(config.paddingTop){
            style.paddingTop = config.paddingTop + 'px'
        }
        if(config.paddingRight){
            style.paddingRight = config.paddingRight + 'px'
        }
        if(config.paddingBottom){
            style.paddingBottom = config.paddingBottom + 'px'
        }

        if(config.borderRadius){
            style.borderRadius = config.borderRadius + 'px'
        }

        if(config.width){
            style.width = config.width + 'px'
        }
        if(config.height){
            style.height = config.height + 'px'
        }
        if(config.textAlign){
            style.textAlign = config.textAlign
        }
        if(config.fontWeight){
            style.fontWeight = config.fontWeight
        }
        if(config.fontStyle){
            style.fontStyle = config.fontStyle
        }
        return style
    }
}


// WEBPACK FOOTER //
// ./src/assets/js/util/util.js